import { useUiStore } from '@app/core/ui/stores/ui.store';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { getSidebarIconButtonSx } from '../sidenav-colors';
import { THEME_TOGGLE_TOUR_ELEMENT_ID, useThemeToggleTour } from './useThemeToggleTour';

const lightModeTooltipMessage = defineMessage({
  id: 'core.sidenav.lightModeTooltip',
  defaultMessage: 'Modo claro',
});

const darkModeTooltipMessage = defineMessage({
  id: 'core.sidenav.darkModeTooltip',
  defaultMessage: 'Modo oscuro',
});

/** Toggles the app theme between light and dark mode from the sidenav footer. */
export function ThemeToggle() {
  const { closeTour } = useThemeToggleTour();
  const toggleThemeMode = useUiStore((state) => state.toggleThemeMode);
  // Sidenav wraps its tree in a fixed darkTheme ThemeProvider, so MUI useTheme()
  // always reports dark mode. Read the persisted app preference from the UI store.
  const isDark = useUiStore((state) => state.themeMode === 'dark');

  const handleToggle = () => {
    closeTour();
    toggleThemeMode();
  };

  return (
    <Tooltip
      title={
        isDark ? (
          <FormattedMessage {...lightModeTooltipMessage} />
        ) : (
          <FormattedMessage {...darkModeTooltipMessage} />
        )
      }
      placement="top"
    >
      <IconButton
        id={THEME_TOGGLE_TOUR_ELEMENT_ID}
        onClick={handleToggle}
        sx={getSidebarIconButtonSx}
      >
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}
